import { commonIcons } from '../common/icon';
import { IIcon } from '../types/icon';

export const icon: IIcon = {
  ...commonIcons,
  bkCrown: 'bkCrown',
  order: 'order',
  rewards: 'bkCrown',
};
